module.exports = __webpack_public_path__ + "img/11069860_L.d2db04fe.png";